import { faIdCard, faToggleOn } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/usePublication'

const generateTabBarItems = (publication) => {
  const urls = generateUrls(publication)
  const { editPublicationRelationsUrl, editPublicationUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editPublicationUrl,
      key: 'details',
      title: publication?.title || 'Publication Details',
    },
    {
      icon: faToggleOn,
      href: editPublicationRelationsUrl,
      key: 'relations',
      title: 'Relations',
    },
  ]
}

export default generateTabBarItems
